module.exports = __webpack_public_path__ + "static/image4-524fa052c88e689b0628d372c96122f8.jpg";